import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import { Header } from '../lib/header'

import IconChevronDown from './IconChevronDown'

const SHeader = styled.div`
    display: flex;
    justify-content: space-between;
`

const SBackButtonContainer = styled.div`
    display: flex;
    align-items: center;
`

const SBackButton = styled.button`
    display: flex;
    align-items: center;
    color: #093aa3;
    font-weight: 500;
    font-size: 14px;
    background-color: transparent;
    border: none;
`

const SBackIcon = styled(IconChevronDown)`
    fill: #093aa3;
    height: 8px;
    transform: rotate(90deg);
`

const MainPageLayout: React.FC<Props> = ({ children, title, backButton }) => {
    const navigate = useNavigate()
    return (
        <div className="page-layout-container">
            <div className="row">
                {title && (
                    <SHeader className="col-xs-12">
                        <div className="margin-top-small">
                            <Header message={title} size="lg" />
                        </div>
                        {backButton && (
                            <SBackButtonContainer>
                                <SBackButton onClick={() => navigate(backButton.link ? backButton.link : -1)}>
                                    <SBackIcon />
                                    {backButton.title}
                                </SBackButton>
                            </SBackButtonContainer>
                        )}
                    </SHeader>
                )}
                <div className="col-xs-12">
                    <div className="margin-top-small margin-bottom-small">{children}</div>
                </div>
            </div>
        </div>
    )
}

export default MainPageLayout

type Props = PropsWithChildren<{
    title?: string
    backButton?: {
        title: string
        link?: string
    }
}>
